import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function swiper2() {

  const swiper2 = new Swiper('.swiper-container-2', {

    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 10,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
    },
  });
}
